import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "popup__content" }
const _hoisted_2 = { class: "alert mb-sm" }
const _hoisted_3 = {
  class: "form-check-label",
  for: "blacklistAgreement"
}
const _hoisted_4 = { class: "popup__controls" }
const _hoisted_5 = { class: "text-capitalize-first" }
const _hoisted_6 = { class: "text-capitalize-first" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_LoaderButton = _resolveComponent("LoaderButton")!
  const _component_Popup = _resolveComponent("Popup")!

  return (_openBlock(), _createBlock(_component_Popup, {
    ref: (el) => _ctx.popup = el,
    "hide-title": true,
    onOnClose: _ctx.hide
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_FormInputWrapper, {
              field: "isAgreeBlacklistPaymentMethod",
              form: "agreement"
            }, {
              default: _withCtx((parentProps) => [
                _createElementVNode("div", {
                  class: _normalizeClass(["", parentProps.class])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.isAgreeBlacklistPaymentMethod) = $event)),
                    type: "checkbox",
                    value: "",
                    id: "blacklistAgreement"
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.form.isAgreeBlacklistPaymentMethod]
                  ]),
                  _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.helper.trans('labels.agree_with_risk')), 1)
                ], 2)
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args))),
            class: "btn popup__close"
          }, [
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('button.cancel')), 1)
          ]),
          _createVNode(_component_LoaderButton, {
            "on-click": _ctx.onOkClick,
            class: "btn btn--accept"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.helper.trans('button.ok')), 1)
            ]),
            _: 1
          }, 8, ["on-click"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onOnClose"]))
}